
// Methods
import moment from "moment";

export function convertHMS (value) {
  const milliseconds = (value+"").split(".")[1]
  const sec = parseInt(value, 10) // convert value to number if it's string
  let hours = Math.floor(sec / 3600) // get hours
  let minutes = Math.floor((sec - (hours * 3600)) / 60) // get minutes
  let seconds = sec - (hours * 3600) - (minutes * 60) //  get seconds
  // add 0 if value < 10; Example: 2 => 02
  if (hours < 10) { hours = '0' + hours }
  if (minutes < 10) { minutes = '0' + minutes }
  if (seconds < 10) { seconds = '0' + seconds }
  return hours + ':' + minutes + ':' + seconds + (milliseconds ? '.' + milliseconds : '') // Return is HH : MM : SS
}

/**
 * @param value
 * @throws Error
 * @description transform the HMS text to seconds
 */
export function convertHMSToS(value) {
  const valueArr = value.split(':');
  if (valueArr.length !== 3) {
    throw Error('Invalid format')
  }
  const hour = parseFloat(valueArr[0]);
  const min = parseFloat(valueArr[1]);
  const sec = parseFloat(valueArr[2]);

  if (min > 60 || sec > 60) {
    throw Error('Invalid format')
  }
  return (hour * 3600) + (min * 60) + sec
}

export function formatTime(timestampMs) {
  const d = new Date(timestampMs);
  const h = String(d.getHours()).padStart(2, '0');
  const m = String(d.getMinutes()).padStart(2, '0');
  const s = String(d.getSeconds()).padStart(2, '0');
  return `${h}:${m}:${s}`;
}


export function timeFromTs(ts, show_ms = false, use_utc = false) {
  if(ts.toString().length === 10) ts = ts *1000
  let format = 'HH:mm:ss';
  if(show_ms) format = 'HH:mm:ss.SSS';
  if(use_utc) return moment(ts).utc().format(format)
  else return moment(ts).format(format)
}

export function getClipsDuration(clips) {
  let duration = 0;
  if (!clips.length) return duration
  clips?.map(clip => {
    if (clip.trim) {
      duration += (clip.trim.end - clip.trim.start) / 1000;
    } else {
      duration += clip.duration || 0;
    }
  })
  clips?.map(clip => {
    if (clip.transition)
      duration -= clip.transition.duration
  })
  return duration;
}


export function getClipDuration (clip) {
  let duration = clip.duration || 0
  if (clip.trim) {
    duration = (clip.trim.end - clip.trim.start) / 1000;
  }
  return duration;
}

export function getImageURL(image_name) {
  if(!image_name) return null;
  return `${process.env.VUE_APP_BASE_URL}public/images/${image_name}`;
}
